import React from "react";

const FooterContent = (props) => {
    return (
        <>
        Gift Card Granny is operated by Wolfe LLC. Products available are sold by Gift Card Granny, other than items on
        partner sites which are sold by the gift card marketplace site specified by the referral link. 
        Your use of this site subjects you to Gift Card Granny's <a href={props.baseUrl+'/terms/'}>terms of use</a>, <a href={props.baseUrl+'/terms-cart/'}>terms and conditions</a>, <a href={props.baseUrl+'/privacy-policy/'}>privacy policy</a>, <a href={props.baseUrl+'/image-guidelines/'}>image guidelines</a> and <a href={props.baseUrl+'/refund-return-policy/'}>refund & return policy</a>. All designated trademarks and brands are the property of their respective owners.
        No claims of affiliation are made about the stores on this site. © Copyright 2010-2020 Gift Card Granny LLC. 
        The Gift Card Granny Visa® Gift Card is issued by Sutton Bank®, Member FDIC, pursuant to a license from Visa U.S.A. Inc. 
        The Visa Gift Card can be used everywhere Visa debit cards are accepted in the US. No cash or ATM access. 
        The Gift Card Granny Mastercard® Gift Card is issued by Sutton Bank, Member FDIC, pursuant to a license by Mastercard International Incorporated. 
        Use your Mastercard Gift Card everywhere Debit Mastercard is accepted in the US. Mastercard is a registered trademark, 
        and the circles design is a trademark of Mastercard International Incorporated.
        </>
    );
}

export default FooterContent;